import React from "react"
import ApiService from "@bodeboca/api"

const Header = ({
  title = '',
  subtitle = '',
  backgroundImage = '',
  iconClass = '',
  size = 'extra-large'
}) => {

  const header = ApiService.getHeader()
  if (header) {
    title = header['title']
    subtitle = header['subtitle']
    size = header['size']
  }

  return (<>
    { header || title !== '' &&
      <div className={'bb-custom-header bb-custom-header-' + size}>
        <div className={'title-wrapper'}>

          <h1 className={'title ' + (iconClass ? 'icon-title ' + iconClass : '')}>{title}</h1>
        </div>
        <h2 className={'subtitle'}>{subtitle}</h2>
      </div> }
  </>)
}

export default Header
